import PropTypes from "prop-types";
import React from "react";
import styles from "./Progress.module.scss";

const Progress = ({ className, value }) => {
  return (
    <div className={`${styles.ProgressBar} ${className || ""}`}>
      <div className={styles.Progress} style={{ width: `${value}%` }}></div>
    </div>
  );
};

Progress.propTypes = {
  value: PropTypes.number,
};

Progress.defaultProps = {
  value: 33,
};

export default Progress;
